function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M66 30.5286V33.5186C65.996 40.527 63.7266 47.3463 59.5303 52.9595C55.334 58.5728 49.4357 62.6791 42.7149 64.6663C35.9941 66.6534 28.8111 66.4148 22.237 63.986C15.663 61.5572 10.0501 57.0684 6.23562 51.1891C2.42112 45.3097 0.609321 38.3548 1.07045 31.3616C1.53158 24.3684 4.24092 17.7117 8.79441 12.3841C13.3479 7.05651 19.5015 3.34359 26.3376 1.79908C33.1737 0.254559 40.3259 0.961197 46.7275 3.8136",
  stroke: "#27AE60",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66 7.51953L33.5 40.052L23.75 30.302",
  stroke: "#27AE60",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGreenCheck2 = function SvgGreenCheck2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenCheck2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green-check-2.8786fc88.svg";
export { ForwardRef as ReactComponent };